import { ButtonColorTheme, PopupSize, PopupTemplate } from "..";

export interface RevertToLegacyProjectDeleteTaskPopupProps {
  onClose: () => void;
  onConfirm: () => void;
}

export const RevertToLegacyProjectDeleteTaskPopup = (
  props: RevertToLegacyProjectDeleteTaskPopupProps,
) => {
  const { onClose, onConfirm } = props;
  return (
    <PopupTemplate
      {...{
        title: "Delete tasks to switch to legacy project",
        description:
          "This project type was used before June 2025. It doesn’t support event trackers or real schedules. Tasks are always persistent, with schedules written into each task. To switch to a legacy project, please delete all existing tasks first.",
        background: true,
        popupSize: PopupSize.Small,
        handleClosePopup: () => onClose(),
        mainFunction: () => onConfirm(),
        buttonContent: "I Got It",
        buttonColorTheme: ButtonColorTheme.Primary,
      }}
    />
  );
};
